import React from "react";
import { Link } from 'react-router-dom';
import Header from '../common/header/Header';
import FooterOne from '../common/footer/FooterOne';
import SEO from '../common/SEO';

const Employment = () => {
    return (
        <>
            <SEO title="Employment - Skills Needed" />
            <main className="main-wrapper">
                <Header />
                
                {/* Centered Content */}
                <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh', padding: '2rem', marginTop: '80px' }}>
                    <div className="text-center" style={{ maxWidth: '800px', width: '100%' }}>
                        
                        {/* Header */}
                        <h1 className="mb-4 fw-bold" style={{ fontSize: '2.5rem', color: 'var(--color-heading)' }}>
                            Skills Needed At East Coast Coders LLC
                        </h1>
                        
                        {/* Content */}
                        <div className="mb-5">
                            <div className="mb-3 p-3" style={{ 
                                backgroundColor: '#f8f9fa', 
                                borderRadius: '12px',
                                border: '1px solid #e9ecef'
                            }}>
                                <p className="mb-2" style={{ fontSize: '1.1rem', fontWeight: 'normal' }}>Database Administrator - SQL Server - SQL Guru - Backup Support - Moving database skills - Performance tuning - SQL diagnostics - ETL skills to support updating tables to correct data problems - SQL Server Security</p>
                            </div>
                            <div className="mb-3 p-3" style={{ 
                                backgroundColor: '#f8f9fa', 
                                borderRadius: '12px',
                                border: '1px solid #e9ecef'
                            }}>
                                <p className="mb-2" style={{ fontSize: '1.1rem', fontWeight: 'normal' }}>Windows Server Activation Issues - RDS CALs (Remote Desktop Services Client Access Licenses) support - regedit.exe skills - Windows Versioning Skills for migration support - Security Skills - Roles and permission understanding</p>
                            </div>
                            <div className="mb-5 p-3" style={{ 
                                backgroundColor: '#f8f9fa', 
                                borderRadius: '12px',
                                border: '1px solid #e9ecef'
                            }}>
                                <p className="mb-2" style={{ fontSize: '1.1rem', fontWeight: 'normal' }}>Desktop Support Engineer - Troubleshoot VPN access to cloud server with printing locally support - OpenVPN skills - Network knowledge to troubleshoot firewalls and various routers - Familiarity with AI-assisted diagnostic and monitoring tools</p>
                            </div>
                        </div>
                        
                        {/* Contact Button */}
                        <div>
                            <Link 
                                to="/" 
                                className="axil-btn btn-fill-primary"
                                style={{ 
                                    padding: '15px 30px', 
                                    fontSize: '1.1rem',
                                    textDecoration: 'none',
                                    display: 'inline-block'
                                }}
                                onClick={() => {
                                    // Small delay to allow navigation to complete, then scroll to about section
                                    setTimeout(() => {
                                        const aboutSection = document.querySelector('.section.section-padding-equal.bg-color-light');
                                        if (aboutSection) {
                                            aboutSection.scrollIntoView({ behavior: 'smooth' });
                                        }
                                    }, 200);
                                }}
                            >
                                Contact Us
                            </Link>
                        </div>
                        
                    </div>
                </div>
                
            </main>
        </>
    );
};

export default Employment;